export interface ListDataProps {
  iidx: number;
  iidx2: number;
  courtcode: string;
  unitno: string;
  type: string;
  address: string;
  caseno: string;
  courtname: string;
  category: string;
  viewgray: string;
  l_area: number;
  l_pyeong: number;
  b_area: number;
  b_pyeong: number;
  viewgray2: string;
  a_price: string;
  minprice: string;
  bidprice: string;
  status: string;
  saledate: string;
  count: string;
  bid: string;
  bidno: number;
  isblockdeal: string;
  img: string;
  Img: {
    imgNo: string;
    src: string;
    description: string;
  }[];
  minPrice: number;
  isBid: boolean;
  b_item_info: string[];
  a_per: number;
  is_like: boolean;
  level: number;
  group: string;
  memo: string | null;
  group_idx?: number;
}

export type SortOption = { value: string; label: string };

export const SortOptions: SortOption[] = [
  {
    value: 'AD',
    label: '감정가 높은순',
  },
  {
    value: 'AA',
    label: '감정가 낮은순',
  },
  {
    value: 'MD',
    label: '최저가 높은순',
  },
  {
    value: 'MA',
    label: '최저가 낮은순',
  },
  {
    value: 'DA',
    label: '매각기일 빠른순',
  },
  {
    value: 'DD',
    label: '매각기일 늦은순',
  },
  {
    value: 'BD',
    label: '유찰횟수 높은순',
  },
  {
    value: 'BA',
    label: '유찰횟수 낮은순',
  },
  {
    value: 'VD',
    label: '조회수 높은순',
  },
  {
    value: 'VA',
    label: '조회수 낮은순',
  },
];
export interface BondListItemProps {
  a_price: string;
  b_idx: number;
  blue_tag: string;
  d_day: number;
  end_at: string;
  h_price: string;
  img: string;
  is_blind: string;
  is_pressing: string;
  sub_title: string;
  title: string;
  create_at: string;
  viewgray2: string;
  lat: number;
  lng: number;
  addr?: string;
  count?: number;
}
